import React from 'react';
import {Grid} from "@material-ui/core";
import {CustomTabs,} from "../index";
import ProductReviewCard from "./productReviewCard";
import SmartDetailCard, {SmartServiceDetailCard} from "./smartDetailCard";
import FlowDiagram from "../flowDiagram";

const data = []

const productTabsList=[{label: 'product details '}, {label: 'product reviews '}, {label: 'Product Tracking Information'}]
const serviceTabsList=[{label: 'service details '}, {label: 'service reviews '}]
function DetailsSection(props) {
  const {activeTab, handleChangeTab,page} = props;
  return (
    <>
      <Grid md={9} className='mt-20'>
        <Grid md={12} style={{borderBottom: '1px solid C4C4C4'}}>
          <Grid md={12}>
            <CustomTabs
              activeTab={activeTab} handleChange={handleChangeTab}
              tabsList={page==='service'?serviceTabsList:productTabsList}/>
          </Grid>
        </Grid>
        <Grid  lg={12} className='mt-20 overflow-auto' style={{maxHeight: 500}}>
          {activeTab === 0 ?
             page==='service'?<SmartServiceDetailCard prodcut={props.product}/>: <SmartDetailCard product={props.product}/>
             :
            activeTab === 1&&
              <table className='product-review-section full-width '>
                {data.map(item => (<ProductReviewCard key={item}/>))}
              </table>
          }
        </Grid>
      </Grid>
    </>
  )
    ;
}

export default DetailsSection;
